import { MessageCircle, Zap, ArrowRight } from 'lucide-react';

const steps = [
  {
    n: '01',
    icon: MessageCircle,
    title: 'Chat with THEO',
    body:
      'One question at a time, THEO assembles a complete research brief — geography, filters, decision-maker roles, enrichment depth, budget cap, output target. You confirm. Reusable as a playbook.',
  },
  {
    n: '02',
    icon: Zap,
    title: 'Brain runs',
    body:
      'Web search and verification kick off across multiple sources. Optional voice + email engaged when the brief asks for them. Per-step cost ledger, source citations on every fact, hard stop at your budget cap.',
  },
  {
    n: '03',
    icon: ArrowRight,
    title: 'Lands in your CRM',
    body:
      'Companies, contacts, decision-makers, opening lines, recent triggers, complaint summary — all tagged, piped to the right pipeline + stage, owner assigned, optional auto-task. Click outreach.',
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how" className="relative overflow-hidden bg-gradient-to-b from-ink-950 to-ink-900 py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-3xl text-center">
          <p className="mb-4 text-sm font-semibold uppercase tracking-wider text-rose-400">
            How it works
          </p>
          <h2 className="text-4xl font-bold tracking-tight text-white sm:text-5xl">
            From a sentence to a sourced answer in minutes.
          </h2>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                className="relative rounded-2xl border border-white/10 bg-ink-900/40 p-8"
              >
                <div className="mb-6 flex items-center gap-3">
                  <span className="text-xs font-mono text-rose-400">{s.n}</span>
                  <span className="h-px flex-1 bg-gradient-to-r from-rose-500/30 to-transparent" />
                </div>
                <div className="mb-4 inline-grid h-12 w-12 place-items-center rounded-xl bg-rose-500/10 ring-1 ring-rose-500/20">
                  <Icon className="h-6 w-6 text-rose-400" strokeWidth={1.75} />
                </div>
                <h3 className="mb-3 text-xl font-bold text-white">{s.title}</h3>
                <p className="text-sm leading-relaxed text-slate-400">{s.body}</p>
                {i < steps.length - 1 && (
                  <ArrowRight className="absolute right-4 top-1/2 hidden h-5 w-5 -translate-y-1/2 text-rose-500/40 md:block" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
